'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _value = require('../models/value');

var _value2 = _interopRequireDefault(_value);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Changes.
 *
 * @type {Object}
 */

var Changes = {};

/**
 * Set `properties` on the value.
 *
 * @param {Change} change
 * @param {Object|Value} properties
 * @param {Object} options
 */

Changes.setValue = function (change, properties) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  properties = _value2.default.createProperties(properties);
  var value = change.value;


  change.applyOperation({
    type: 'set_value',
    properties: properties,
    value: value
  }, options);
};

/**
 * Export.
 *
 * @type {Object}
 */

exports.default = Changes;


//////////////////
// WEBPACK FOOTER
// ./node_modules/slate/lib/changes/on-value.js
// module id = 1304
// module chunks = 0